import ProductSelector from "../../../products/components/ProductsSelector";
import DateField from "../../../shared/components/forms/DateField";
import { CreateProjectLicensesModel } from "../../../../domain/projectLicenses/CreateProjectLicensesModel";

interface Props {
    projectLicenses: CreateProjectLicensesModel;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => void;
}

export default function ModalCreateProjectLicensesSection({
    projectLicenses,
    onChange: handleInputChange,
}: Props) {
    const formatDate = (date?: string | Date): string => {
        const parsed = typeof date === 'string' ? new Date(date) : date;
        return parsed instanceof Date && !isNaN(parsed.getTime())
            ? parsed.toISOString().split('T')[0]
            : '';
    };

    return (
        <div>
            <div className='col-12 mb-3'>
                <ProductSelector
                    name='productId'
                    value={projectLicenses.productId}
                    isLicensed = {true}
                    onChange={handleInputChange}
                />
            </div>

            <div className='col-12 mb-3'>
                <label className='form-label'>Cantidad de Licencias:</label>
                <div className='input-group' style={{ maxWidth: 200 }}>
                    <button
                        className='btn btn-light'
                        type='button'
                        onClick={() =>
                            handleInputChange(
                                'quantity',
                                Math.max(0, projectLicenses.quantity - 1)
                            )
                        }
                    >
                        -
                    </button>
                    <input
                        type='number'
                        className='form-control text-center'
                        value={projectLicenses.quantity}
                        min={0}
                        onChange={(e) =>
                            handleInputChange('quantity', Number(e.target.value))
                        }
                    />
                    <button
                        className='btn btn-light'
                        type='button'
                        onClick={() =>
                            handleInputChange('quantity', projectLicenses.quantity + 1)
                        }
                    >
                        +
                    </button>
                </div>
            </div>

            <div className='col-12'>
                <DateField
                    label='Fecha de Expiración'
                    name='expirationDate'
                    onChange={handleInputChange}
                    required={true}
                    value={formatDate(projectLicenses.expirationDate)}
                />
            </div>
        </div>
    );
}